import Vue from 'vue'
import Vuex from 'vuex'
import { createAxiosInstance } from '@/axios/index'
import { initConfig, checkFirstLogin, getUserTagKey, userInfo } from '@/axios/base'
import { searchInit } from '@/axios/search'
import { getGroupSetting, getDefaultRegionMapping, queryTag, queryOutputTag } from '@/axios/mediaHub'
import { destTags } from '@/axios/destination'
import cookie from 'js-cookie'
import Tool from '@/assets/js/utils'
import { initSentry } from '@/assets/js/sentry'
import { calendar } from './calendar'

Vue.use(Vuex)

// MH-3512: tagList 取数的 in-flight promise（按 type 去重），不放入 state —— promise 不可序列化且无需响应式 [Claude Code]
const _tagListPromises = {}

// MH-3512: tagList 三类来源与对应接口，筛选面板与列表宿主共用同一份数据 [Claude Code]
const TAG_LIST_APIS = {
  Source: queryTag,
  Destination: destTags,
  Project: queryOutputTag
}

// dest 直播缓存的 timer map，不放入 state（setTimeout 不可序列化） [Claude Code]
const _destLiveCacheTimers = {}

export const storeConfig = {
  state: {
    // sourceObjectId -> { dests: destInfo[], oldSourceObjectId } [Claude Code]
    destLiveCache: {},
    xySwitch: false,
    viewMode: 'card', // 'card' | 'compact' | 'list' | 'xyGrid'
    mediaHubActiveTab: 'hub', // 'hub' | 'schedule'
    logProjectInfo: {
      projectName: '',
      projectId: ''
    },
    mediaInitParams: {
      correctionHoverFlag: false,
      selectedOutput: [],
      disabledOutput: [],
      defaultProfile: null,
      openGuide: false,
      profileOutputLen: {
        outputLen: 0,
        bindProfileLen: 0
      },
      programInfo: {
        domain: '',
        audioChannel: 6,
        resolution: '1080P60'
      },
      destinationList: []
    },
    initConfig: {},
    websocket: {
      pageRequestWs: null,
      pageSerBusRequestWs: null,
      pageSerBusRequestWs2: null,
      pageRWebsocketWs: null,
      pageServerRequestWs: null
    },
    userInfo: {},
    tvuUserInfo: {},
    deviceRPeerIds: [],
    socketDeviceList: {},
    socketProjectObj: {}, // Project的websocket信息
    pushingProfile: {},
    viewSourceList: [],
    permissionList: [],
    isLoadPermission: false,
    userPermission: [],
    operateObject: {
      searchUrl: '' // search后台地址
    },
    // reloadExtImg: false,
    dialogPosition: {
      showDialog: '',
      left: (document.body.clientWidth - 1100) / 2 < 0 ? 0 : (document.body.clientWidth - 1100) / 2,
      top: 100
    },
    checkBilling: true,
    loadDragDemo: false,
    videoCurrentTime: {},
    // webrtc: null,
    firstLogin: false,
    // isLoadedBilling: false,
    postColorCorrectionWindow: null,
    postDestinationWindow: null,
    postArtWindow: null,
    // newDestinationWindow: null,
    adminInfo: {
      loaded: false
    },
    watchWebsokectKeyList: ['userBehavior', 'urlChange', 'whiteBalanceV3', 'MHNotify'],
    previewSourceInfo: {},
    multiAjax401Jump: false,
    newSourceObject: {},
    newProfileObject: {},
    updateThumImgTime: {
      current: {},
      last: {},
      env: {}
    },
    resourceGolbalConfig: 'TVU',
    versionList: [],
    defaultRegionRemapping: {},
    defaultAdminConfig: {},
    routeSourceInfo: null,
    liveFilterItem: null,
    folderInfo: null,
    popSocketInfo: {},
    popPreviewId: '',
    // MH-3512: 按 type 缓存的 tagList 原始接口返回（不含 selected/reversed 等展示态，展示态由筛选面板按当次条件派生）[Claude Code]
    tagListMap: {
      Source: [],
      Destination: [],
      Project: []
    },
    // MH-3512: 各 type 是否已成功取过一次 tagList，用于区分「确实是空列表」与「还没取到」[Claude Code]
    tagListLoaded: {
      Source: false,
      Destination: false,
      Project: false
    }
  },
  mutations: {
    // MH-3512: 写入某 type 的 tagList 缓存并标记已加载；整体替换对象以保证 Vue 2 响应式生效 [Claude Code]
    setTagList (state, data) {
      const { type, list } = data || {}
      if (!type) return
      state.tagListMap = { ...state.tagListMap, [type]: list || [] }
      state.tagListLoaded = { ...state.tagListLoaded, [type]: true }
    },
    updateDefaultRrgionRemapping (state, data) {
      state.defaultRegionRemapping = data
    },
    updateDefaultAdminConfig (state, data) {
      state.defaultAdminConfig = data
    },
    updateVersionList (state, data) {
      state.versionList = data
    },
    updatePostWindow (state, data) {
      const { type, key, value } = data
      if (type == 'update') {
        state[`post${key}Window`].location.href = value
        // 切换到这个 tab
        state[`post${key}Window`].focus()
      } else {
        state[`post${key}Window`] = value
        // console.log(state[`post${key}Window`])
      }
    },
    changeWebSocket (state, data) {
      state.websocket = {
        ...state.websocket,
        ...data
      }
    },
    changeViewSourceList (state, data) {
      state.viewSourceList = data
    },
    changeResourceGlobalConfig (state, data) {
      state.resourceGolbalConfig = data
    },
    changeDeviceRPeerIds (state, data) {
      state.deviceRPeerIds = data
    },
    changePopSocketInfo (state, data) {
      state.popSocketInfo = data
    },
    changePushingProfile (state, data) {
      state.pushingProfile = data
    },
    updateSocketProjectObj (state, data) {
      state.socketProjectObj = data
    },
    changeDragDemo (state, data) {
      state.loadDragDemo = data
    },
    socketDeviceListFn (state, data) {
      state.socketDeviceList = data
    },
    updateThumImgTimeFn (state, data) {
      state.updateThumImgTime = data
    },
    setTvuUserInfo (state, data) {
      state.tvuUserInfo = data
    },
    setNewSourceObject (state, data) {
      state.newSourceObject = data
    },
    setNewProfileObject (state, data) {
      state.newProfileObject = data
    },
    setPreviewSourceInfo (state, data) {
      state.previewSourceInfo = data
    },
    setVideoCurrentTime (state, data) {
      // 使用一个新对象替换原有对象以确保 Vue 能够检测到变化
      state.videoCurrentTime = {
        ...state.videoCurrentTime,
        [data.id]: data.time
      }
    },
    setRouteSourceInfo (state, data) {
      state.routeSourceInfo = data
    },
    setLiveFilterItem (state, data) {
      state.liveFilterItem = data
    },
    setFolderInfo (state, data) {
      state.folderInfo = data
    },
    setPopPreviewId (state, data) {
      state.popPreviewId = data
    },
    setLogProjectInfo (state, data) {
      state.logProjectInfo = data
    },
    setOperateObject (state, data) {
      state.operateObject = data
    },
    setSelectedOutput (state) {
      state.mediaInitParams.selectedOutput = []
    },
    correctionHoverFlag (state, flag) {
      state.mediaInitParams.correctionHoverFlag = flag
    },
    openGuideFlag (state, flag) {
      state.mediaInitParams.openGuide = flag
    },
    saveUserPermission (state, data) {
      state.isLoadPermission = true
      state.userPermission = data
    },

    setDialogPosition (state, data) {
      state.dialogPosition = {
        ...state.dialogPosition,
        ...data
      }
    },
    setCheckBilling (state, data) {
      state.checkBilling = data
    },
    setAdminInfo (state, data) {
      state.adminInfo = data
    },
    setViewMode (state, mode) {
      state.viewMode = mode
      state.xySwitch = mode === 'xyGrid'
    },
    setMediaHubActiveTab (state, tab) {
      state.mediaHubActiveTab = tab
    },
    // 由 timer 回调调用，10s 兜底清除单个 dest 缓存 [Claude Code]
    destLiveCache_removeDest (state, { sourceObjectId, destObjectId }) {
      if (!state.destLiveCache[sourceObjectId]) return
      const dests = state.destLiveCache[sourceObjectId].dests
      const idx = dests.findIndex(d => d.objectId === destObjectId)
      if (idx > -1) dests.splice(idx, 1)
      if (!dests.length) {
        Vue.delete(state.destLiveCache, sourceObjectId)
      }
    }
  },
  actions: {
    // MH-3512: tagList 单点取数出口。筛选面板与列表宿主共用同一份缓存，宿主据此剔除已被删除的 tag key，
    // 不再拿幽灵 key 去查列表（旧行为：面板自己 fetch 自己用，宿主无从校验）。
    // - 有缓存且非 force：直接返回缓存，不发请求
    // - 同 type 并发：合并为一次请求（模块级 in-flight promise）
    // - force：用户点开筛选面板时强制刷新，保证面板看到最新列表
    // - 失败：保留旧缓存并返回当前值，宁可不剔除也不能把用户已选的筛选条件清空 [Claude Code]
    fetchTagList ({ state, commit }, data) {
      const { type, force } = data || {}
      const api = TAG_LIST_APIS[type]
      if (!api) return Promise.resolve([])
      if (!force && state.tagListLoaded[type]) return Promise.resolve(state.tagListMap[type])
      if (_tagListPromises[type]) return _tagListPromises[type]
      const promise = api().then(res => {
        if (res && res.errorCode == '0x0') {
          const list = res.result || []
          commit('setTagList', { type, list })
          return list
        }
        return state.tagListMap[type]
      }).catch(() => {
        return state.tagListMap[type]
      }).finally(() => {
        _tagListPromises[type] = null
      })
      _tagListPromises[type] = promise
      return promise
    },
    async jumpLoginPage ({ state, dispatch }, data) {
      if (state.multiAjax401Jump) return
      state.multiAjax401Jump = true
      localStorage.removeItem('agentDownload')
      window.location.href = `${location.protocol}//${state.initConfig.newuserserviceUrl}/?url=${state.initConfig.mediaHubCallBackUrl}&serviceName=${state.initConfig.serviceName}`
      setTimeout(() => {
        state.multiAjax401Jump = false
      }, 500)
    },
    async getInitConfigFn ({ dispatch }) {
      await dispatch('getInitConfig')
    },
    updateEnvFn ({ dispatch }) {
      getUserTagKey().then(res => {
        if (res.errorCode == '0x0') {
          const result = res.result || {}
          const { tagKey, tagValue } = result
          const cookieList = cookie.get()
          // console.info(1844, 'tagKey', tagKey, tagValue, cookieList)
          if (tagKey && tagValue) {
            let updateEnv = true
            for (const [key, value] of Object.entries(cookieList)) {
              if (tagKey == key && tagValue == value) {
                updateEnv = false
                break
              }
            }
            if (updateEnv) {
              Tool.setTagCookie(tagKey, tagValue)
              window.location.reload()
            }
          }
        }
      }).catch(() => { })
    },
    async getInitConfig ({ state, dispatch }) {
      if (state.initConfig.serviceName) return
      await initConfig().then(async ({ errorCode, result }) => {
        if (errorCode == '0x0') {
          window.versionNewsObj = {
            code: result.versionCode, // versionCode,
            pageSize: 10,
            theme: 'black'
          }
          Vue.prototype.$TVU = {
            http: createAxiosInstance(),
            serverName: result.serviceName,
            userAuthUrl: result.userAuthUrl,
            userGroup: result.userGroupFrontUrl,
            gateway: `${location.protocol}//${result.gatewayUrl}`,
            mediaHub: process.env.NODE_ENV == 'development' ? 'media-hub-dev.tvunetworks.com' : window.location.hostname // 'media-hub-dev.tvunetworks.com'
          }
          // console.info('config', Vue.prototype.$TVU, Vue.prototype.$TVUMx)
          // 修改mxMediaService参数传递方式
          Vue.prototype.$TVUMx = {
            ...Vue.prototype.$TVUMx,
            userseviceUrl: `${location.protocol}//${result.userAuthUrl}`,
            mxMediaApiUrl: `${location.protocol}//${result.mediaApiUrl}`, // 用于media接口
            mxMediaServerUrl: `${location.protocol}//${result.mediaFrontUrl}`, // 用于media js
            userserviceApi: `${location.protocol}//${result.userAuthUrl}`,
            audioMxUI: result.audioMxUI,
            useNewSidebarUI: true
          }
          state.initConfig = result
          await dispatch('getRoleAndUserInfoFn', true)
        }
      }).catch(() => { })
    },
    async getRoleAndUserInfoFn ({ state, dispatch }, status) {
      if (status && state.userInfo.id) return
      // getAdminConfig 只依赖 initConfig，不依赖 userInfo，与 userInfo 并行发起
      dispatch('getAdminConfig')
      await userInfo().then(res => {
        if (res.errorCode == '0x0') {
          const result = res.result || {}
          state.userInfo = result
          dispatch('getSearchInitConfig')
          initSentry(res.result.email, Tool.getEnvironment())
        }
      }).catch(() => { })
      if (state.userInfo.id) {
        dispatch('getUserAuth')
      }
    },
    getSearchInitConfig ({ state }) {
      searchInit(state.initConfig.searchObjectUrl).then(res => {
        if (res.errorCode == '0x0') {
          const result = res.result || {}
          let TagValue = ''
          const userTag = JSON.parse(result.userTag)
          if (userTag.errorCode === '0x0' && userTag.result) {
            const { tagValue } = userTag.result
            TagValue = tagValue
          }
          const operateObject = {
            searchUrl: state.initConfig.searchObjectUrl,
            objectUrl: state.initConfig.objectUIPath,
            userInfoID: state.userInfo.id,
            email: result.email,
            baseUrl: result.baseUrl,
            serviceName: result.serviceNameInEureka,
            blobservice: result.blobservice,
            ABCNewsOneGroupId: result.ABCNewsOneGroupId,
            slugUpdateBusinessId: result.slugUpdateBusinessId,
            rootGroup: result.rootGroup[0] || {},
            videoImgUrl: result.videoImgUrl,
            receiverDomain: result.receiverDomain,
            useDomainType: result.useDomainType,
            userServiceWebSocket: result.userServiceWebSocket,
            tagValue: TagValue,
            languageList: result.languageList,
            recordTemplateFeature: result.recordTemplateFeature,
            sessionId: cookie.get('SID') || result.SID,
            init: true
          }
          state.operateObject = operateObject
        }
      }).catch(() => { })
    },
    async getAdminConfig ({ state, dispatch, commit }) {
      await getDefaultRegionMapping().then(res => {
        if (res.errorCode == '0x0') {
          commit('updateDefaultRrgionRemapping', res.result)
        }
      }).catch(() => { })
      const defaultConfig = {
        filterStyle: '1',
        colorCorrection: '0',
        ingesting: '0',
        enableInSync: '0',
        canEditPort: '0',
        configRegion: '0',
        audioOnly: '0',
        tsDuck: '0',
        smpte2022_7: '0',
        disasterRecovery: '0',
        mxlIntegration: '0',
        packIntegration: '0',
        jpegXSCodec: '0',
        encoding4K: '0',
        outputUIType: 'destination',
        staticIp: '0',
        tvuVendor: state.defaultRegionRemapping.vendor,
        autoShutDown: '1',
        MA: '0',
        closePreviewWhenNoOutput: '1',
        wmlicenseKey: '',
        // 跟随输入档位的 UI 文案开关（MH-3242）：'0'=显示 Follow Input（默认）、'1'=显示 Passthrough；
        // 随该 defaultConfig 的 keys 一起被 getGroupSetting 拉取，老 group 缺值经下方 value||default 兜底为 '0' [Claude Code]
        followInputLabel: '0',
        // 多 tag 筛选匹配模式（MH-3456）：'all'=全部匹配、'any'=任一匹配、'expose'=交给用户选择；缺值兜底为 'all' [Claude Code]
        tagFilterMode: 'all'
      }
      commit('updateDefaultAdminConfig', defaultConfig)
      let keys = ''
      Object.keys(defaultConfig).forEach(key => {
        keys += key + ','
      })
      let config = {}
      getGroupSetting(state.initConfig.groupId, keys.slice(0, keys.length - 1)).then(res => {
        if (res.errorCode == '0x0') {
          config = res.result || {}
        }
      }).catch(() => {

      }).finally(() => {
        dispatch('commitAdminPermission', { defaultConfig, config })
      })
    },
    commitAdminPermission ({ state }, { defaultConfig, config }) {
      let newConfig = {}
      Object.entries(config).forEach(([key, value]) => {
        if (key != 'groupId') {
          newConfig[key] = value || defaultConfig[key]
        }
      })
      const _config = {
        ...defaultConfig,
        ...newConfig,
        loaded: true
      }
      state.adminInfo = _config
    },
    getUserAuth ({ state }) {
      new Vue().$getUserAuth({
        ...Vue.prototype.$TVU, // 参考开发手册设置的全局配置
        params: {
          // 请求接口所需要的参数
          showAllPermission: true, // true:显示该服务下所有的permission列表，不论是否有开启权限。false：只显示有权限的permission列表
          serviceNameList: [state.initConfig.serviceName] // 各个服务具体传参参数咨询chris
        },
        success: function (val) {
          // 接口成功的回调，返回result
          state.permissionList = val[0].permissionList
        },
        error: function (val) {
          // 接口失败的回调，会包含失败的状态码
          // console.info(val)
        }
      })
    },
    async isFirstLogin ({ state }) {
      checkFirstLogin({
        serviceName: state.initConfig.serviceName
      }).then(res => {
        if (res.errorCode == '0x0') {
          state.firstLogin = res.result
        }
      }).catch(() => { })
    },
    // 处理 dest 直播状态变化，写入 store，供所有组件订阅 [Claude Code]
    destLiveStatusChange ({ state, commit }, { action, sourceObjectId, oldSourceObjectId, destInfo }) {
      const setCacheTimer = (srcId, destId) => {
        const key = `${srcId}_${destId}`
        clearTimeout(_destLiveCacheTimers[key])
        _destLiveCacheTimers[key] = setTimeout(() => {
          commit('destLiveCache_removeDest', { sourceObjectId: srcId, destObjectId: destId })
          delete _destLiveCacheTimers[key]
        }, 20000)
      }
      const clearCacheTimer = (srcId, destId) => {
        const key = `${srcId}_${destId}`
        clearTimeout(_destLiveCacheTimers[key])
        delete _destLiveCacheTimers[key]
      }

      // folder 子 dest 辅助函数：生成扁平 destInfo 条目，继承父级的 email/userId/createTime [Claude Code]
      const makeFolderDest = (dest) => ({
        objectId: dest.objectId,
        outputId: dest.tangibleId,
        outputName: dest.tangibleName,
        businessId: destInfo.objectId,
        businessName: destInfo.outputName,
        destinationObject: false,
        email: destInfo.email || '',
        userId: destInfo.userId || '',
        status: null,
        createTime: destInfo.createTime || null
      })

      // 数组 upsert：存在则更新，不存在则追加 [Claude Code]
      const upsertDest = (dests, info) => {
        const idx = dests.findIndex(d => d.objectId === info.objectId)
        if (idx > -1) {
          Vue.set(dests, idx, info)
        } else {
          dests.push(info)
        }
      }

      // 数组删除：按 objectId 查找并 splice [Claude Code]
      const removeDest = (dests, destObjectId) => {
        const idx = dests.findIndex(d => d.objectId === destObjectId)
        if (idx > -1) dests.splice(idx, 1)
      }

      // 判断是否为 folder 展开模式（destinations 非空）[Claude Code]
      const folderDests = destInfo.destinations && destInfo.destinations.length ? destInfo.destinations : null

      if (action === 'start') {
        if (!state.destLiveCache[sourceObjectId]) {
          Vue.set(state.destLiveCache, sourceObjectId, { dests: [], oldSourceObjectId: null })
        }
        if (folderDests) {
          // folder：逐个子 dest 写入缓存 [Claude Code]
          folderDests.forEach(dest => {
            upsertDest(state.destLiveCache[sourceObjectId].dests, makeFolderDest(dest))
            setCacheTimer(sourceObjectId, dest.objectId)
          })
        } else {
          upsertDest(state.destLiveCache[sourceObjectId].dests, destInfo)
          setCacheTimer(sourceObjectId, destInfo.objectId)
        }
      } else if (action === 'switch') {
        // 收集本次涉及的 destId 列表，统一处理旧 source 清理 [Claude Code]
        const destIds = folderDests ? folderDests.map(d => d.objectId) : [destInfo.objectId]
        // 从旧 source 清除 [Claude Code]
        if (oldSourceObjectId && state.destLiveCache[oldSourceObjectId]) {
          destIds.forEach(destId => {
            clearCacheTimer(oldSourceObjectId, destId)
            removeDest(state.destLiveCache[oldSourceObjectId].dests, destId)
          })
          if (!state.destLiveCache[oldSourceObjectId].dests.length) {
            Vue.delete(state.destLiveCache, oldSourceObjectId)
          }
        }
        // 写入新 source [Claude Code]
        if (!state.destLiveCache[sourceObjectId]) {
          Vue.set(state.destLiveCache, sourceObjectId, { dests: [], oldSourceObjectId })
        }
        if (folderDests) {
          folderDests.forEach(dest => {
            upsertDest(state.destLiveCache[sourceObjectId].dests, makeFolderDest(dest))
            setCacheTimer(sourceObjectId, dest.objectId)
          })
        } else {
          upsertDest(state.destLiveCache[sourceObjectId].dests, destInfo)
          setCacheTimer(sourceObjectId, destInfo.objectId)
        }
        if (!state.destLiveCache[sourceObjectId].oldSourceObjectId) {
          Vue.set(state.destLiveCache[sourceObjectId], 'oldSourceObjectId', oldSourceObjectId)
        }
      } else if (action === 'stop') {
        if (folderDests) {
          // folder stop：逐个子 dest 清除 [Claude Code]
          folderDests.forEach(dest => {
            clearCacheTimer(sourceObjectId, dest.objectId)
            if (state.destLiveCache[sourceObjectId]) {
              removeDest(state.destLiveCache[sourceObjectId].dests, dest.objectId)
            }
          })
        } else {
          clearCacheTimer(sourceObjectId, destInfo.objectId)
          if (state.destLiveCache[sourceObjectId]) {
            removeDest(state.destLiveCache[sourceObjectId].dests, destInfo.objectId)
          }
        }
        if (state.destLiveCache[sourceObjectId] &&
          !state.destLiveCache[sourceObjectId].dests.length) {
          Vue.delete(state.destLiveCache, sourceObjectId)
        }
      }
    }
  },
  modules: {
    calendar
  }
}

const store = new Vuex.Store(storeConfig)

export default store
